import BrandResults from "./BrandResults";

export default BrandResults;
